import api from '@/api/infections'

import delay from '@/sui/api/delay'

const state = function () {
  return {
    fromVersion: {
      bact: {},
      seps: {},
      pneu: {}
    },

    all: {
      '2019': {
        bact: null,
        seps: null,
        pneu: null
      },

      '2020': {
        bact: null,
        seps: null,
        pneu: null
      },

      '2021': {
        bact: null,
        seps: null,
        pneu: null
      },

      '2022': {
        bact: null,
        seps: null,
        pneu: null
      },

      '2023': {
        bact: null,
        seps: null,
        pneu: null
      },

      '2024': {
        bact: null,
        seps: null,
        pneu: null
      },

      '2025': {
        bact: null,
        seps: null,
        pneu: null
      },

      '2026': {
        bact: null,
        seps: null,
        pneu: null
      }
    }
  }
}

// getters
const getters = {
}

// actions
const actions = {
  all ({ state, commit }, request) {
    const t = request.inf
    const y = `${request.y}`
    const cache = state.all[y][t]
    if (cache == null || request.force) {
      return api.all(request).then(
        r => {
          if (r.data.err == null) {
            commit('setAll', { type: t, year: y, values: r.data.v })
          }
          return r
        }
      )
    }

    return delay(10)({ data: { v: cache } })
  },

  transform ({ commit }, request) {
    return api.transform(request)
  },

  fromVersion ({ commit }, request) {
    return api.fromVersion(request)
  }
}

// mutations
const mutations = {
  setAll (state, data) {
    const sorted = data.values.sort(
      (f, s) => f.surv < s.surv ? -1 : f.surv > s.surv ? 1 : 0
    )

    state.all[data.year][data.type] = Object.freeze(sorted)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
